import React from 'react';
import PropTypes from 'prop-types';
import { Label } from '@hydra/common/components';

import DCUrl from '@hydra/routes/crawler/utils/DCUrl';
import { Link } from '@material-ui/core';

function LinkMaybe ({ children, url }) {
  return url.fullPath ? <Link href={url.fullPath} target='_blank' rel='nofollow noopener noreferrer'>{children}</Link> : children;
}

function DCUrlLabel ({ className, url }) {
  return (
    <LinkMaybe url={url}>
      <Label
        noBackground
        truncate
        className={className}
        title={url.visibleUrl}
      >
        {url.visibleUrl}
      </Label>
    </LinkMaybe>
  );
}

DCUrlLabel.propTypes = {
  className: PropTypes.string,
  url: PropTypes.instanceOf(DCUrl),
  severity: PropTypes.number
};

export default DCUrlLabel;
